const warrantySectionId = document.querySelector('[data-id]').dataset.id;
const section = document.querySelector(`.warranty-form--${warrantySectionId}`);
const warrantyForm = section.querySelector('.warranty-form__form');
const successMessage = section.querySelector('.warranty-form__success-message');
const serialNumber = section.querySelector('.warranty-form__serial-number');
const closeBtn = section.querySelector('.warranty-form__close-btn');
const mainContainer = section.querySelector('.warranty-form__main-container');
const serialNumberIcon = section.querySelector('.warranty-form__input-icon');
const submitButton = section.querySelector('.warranty-form__button')
const serialErrorMessage = section.querySelector('.warranty-form__error-message')
const errorMessage = section.querySelector('.warranty-form__global-error-message')
const serialNumberInput = section.querySelector('.warranty-form__input--serial-number')

serialNumberIcon.addEventListener('click', (e) => {
  serialNumber.classList.toggle('warranty-form__serial-number--is-visible');
  mainContainer.classList.toggle('warranty-form__main-container--is-visible', !serialNumber.classList.contains('warranty-form__serial-number--is-visible'));
  closeBtn.classList.toggle('warranty-form__close-btn--is-visible');
});

// Listen to submit button
warrantyForm.addEventListener('submit', (e) => {
  e.preventDefault();
  getFormData(warrantyForm)

  // Remove error message if it is visible
  if (serialErrorMessage.classList.contains('warranty-form__error-message--is-visible')) {
    serialErrorMessage.classList.remove('warranty-form__error-message--is-visible')
  }
  if (errorMessage.classList.contains('warranty-form__global-error-message--is-visible')) {
    errorMessage.classList.remove('warranty-form__global-error-message--is-visible')
  }

  // If the serial number input is currently shown as an error, add the error class
  if (serialNumberInput.classList.contains('warranty-form__input--serial-number-is-error')) {
    serialNumberInput.classList.remove('warranty-form__input--serial-number-is-error');
  }

  const requiredInputs = warrantyForm.querySelectorAll('input[required]');
  let allInputsFilled = true;
  
  // Check if all inputs are filled
  requiredInputs.forEach(input => {
    if (!input.value.trim()) {
      allInputsFilled = false;
    }
  });

  // Send data to API only if all inputs are filled
  if (allInputsFilled) {
    submitButton.classList.add('warranty-form__button--is-submitted')
    sendData(warrantyForm);
  }
});

// Listen to close button
closeBtn.addEventListener('click', (e) => {
  e.preventDefault();
  serialNumber.classList.remove('warranty-form__serial-number--is-visible');
  successMessage.classList.remove('warranty-form__success-message--is-visible');
  mainContainer.classList.add('warranty-form__main-container--is-visible');
  closeBtn.classList.remove('warranty-form__close-btn--is-visible');
});



//- -----------------------------

/* FUNCTIONS */

function getFormData() {
  const formData = new FormData(warrantyForm);
  let formDataObject = Object.fromEntries(formData.entries());

  // Format data to send to API based on the Bounce Swagger API documentation (https://api.bouncesports.co/api#/odoo/OdooController_activateWarrantyFormShopify)
  const newFormData = {
    "lastname": formDataObject.lastname,
    "firstname": formDataObject.firstname,
    "email": formDataObject.email,
    "storeName": formDataObject.shop_name,
    "purchaseDate": formDataObject.purchase_date,
    "serialNumber": formDataObject.serial_number,
    "lang": formDataObject.lang
  }

  // console.log('FORM DATA : ', newFormData);

  return newFormData;
}

function sendData() {
  const formData = getFormData();

  
  window.BounceApi.post('/odoo/activate-warranty', formData)
  .then(async (response) => {
    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch (e) {
        errorDetails = { message: 'Unknown error', statusCode: response.status };
      }
      throw errorDetails;
    }
    return response.json();
  })
  .then(data => {
    // console.log('Success:', data);

    // Show success message and remove loader
    successMessage.classList.add('warranty-form__success-message--is-visible');
    mainContainer.classList.remove('warranty-form__main-container--is-visible');
    closeBtn.classList.add('warranty-form__close-btn--is-visible');
    submitButton.classList.remove('warranty-form__button--is-submitted')
  })
  .catch((error) => {
    // console.log('Error:', error.message);
  
    // Normalize error message to a string for searching
    let errorMsg = '';
    if (Array.isArray(error.message)) {
      errorMsg = error.message.join(' ');
    } else if (typeof error.message === 'string') {
      errorMsg = error.message;
    }
  
    // Check for serial number error
    if (/serial\s*number/i.test(errorMsg) || /serialNumber/i.test(errorMsg)) {
      submitButton.classList.remove('warranty-form__button--is-submitted')
      serialErrorMessage.classList.add('warranty-form__error-message--is-visible')
      serialNumberInput.classList.add('warranty-form__input--serial-number-is-error');
    } else {
      errorMessage.classList.add('warranty-form__global-error-message--is-visible')
      submitButton.classList.remove('warranty-form__button--is-submitted')
    }
  });

}
